import React, { useEffect, useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Image } from 'react-bootstrap';
import logo from '../../assets/images/acumenVelocityLogo.svg';
import { companyRegisterAction } from '../../redux/actions/companyAction';
import CountryCodeDropdown from '../../components/forms/dropDown';
import errorToast from '../../components/toasts/errorToast';
import successToast from '../../components/toasts/successToast';
import { salutation } from '../../components/data/salutation';

const Register = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [signIn, setSignIn] = useState('')
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [selectedCode, setSelectedCode] = useState('');

    const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
    const regex = /^[A-Z0-9]{6}-[A-Z0-9]{6}-[A-Z0-9]{6}$/;
    const uuidRegex = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;

    const initialValues = {
        company_name: "",
        address: "",
        salutation: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        email: '',
        mobile: '',
        sign_in: "",
        password: '',
        confirmPassword: '',
        billing_account: '',
        order_id: ''
    };

    const validationSchema = Yup.object().shape({
        company_name: Yup.string().required('Required'),
        address: Yup.string().required('Required'),
        salutation: Yup.string().required("Required"),
        first_name: Yup.string().required("Required"),
        last_name: Yup.string().required("Required"),
        email: Yup.string().email('Invalid email format').required('Required'),
        mobile: Yup.string().required('Required').matches(/^\d{10}$/, 'Invalid Mobile Number'),
        password: signIn === "email" ? Yup.string()
            .required("Required")
            .matches(passwordRegex, "Password criteria not matching") : "",
        confirmPassword: signIn === "email" ? Yup.string()
            .required("Required")
            .oneOf([Yup.ref("password"), null], "Passwords must match") : "",
        // billing_account: Yup.string().matches(regex, "Invalid Format"),
        // order_id: Yup.string().required('Required').matches(uuidRegex, "Invalid Format"),
    });

    const onSubmit = (values, { resetForm }) => {
        values.mobile = selectedCode + values.mobile;
        console.log('Form data', values);
        dispatch(companyRegisterAction(values, onSuccess, onError));
        resetForm();
        setSelectedCode('+1');
    };

    const onSuccess = (data) => {
        successToast(data.data.message);
        navigate('/');
    };

    const onError = (data) => {
        errorToast(data?.data?.message);
    };

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const toggleShowConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    useEffect(() => {
        document.title = 'Company-register - Acumen Translation Hub';
    }, []);

    const handleKeyPress = (event) => {
        const char = String.fromCharCode(event.which);
        if (!/[a-zA-Z\s]/.test(char)) {
            event.preventDefault();
        }
    };
    return (
        <div className="d-flex flex-column align-items-center min-vh-100" style={{ backgroundColor: '#e9eef7' }}>
            <div
                className="d-flex align-items-center  cursor_pointer p-2 w-100"
                style={{ height: "8vh" }}
                onClick={() => navigate("/")}
            >
                <Image alt="logo" src={logo} height={40} className="mx-2" />
                <p className="name fs_18 fw_600 m-0 ">Acumen Translation Hub</p>
            </div>

            <div className="card p-4 w-100 mx-3 mt-4 shadow-lg" style={{ maxWidth: '800px' }}>
                <h2 className="text-start fs-4">Company Registration</h2>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {({ values, handleChange, handleBlur, resetForm }) => (
                        <Form>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group text-start mb-3">
                                        <label htmlFor="company_name" className="form-label">Company Name</label>
                                        <Field
                                            type="text"
                                            id="company_name"
                                            name="company_name"
                                            className="input-field w-100"
                                            placeholder="Enter Company Name"
                                        />
                                        <ErrorMessage name="company_name" component="div" className="text-danger fs_12" />
                                    </div>

                                    <div className="form-group text-start mb-3">
                                        <label htmlFor="address" className="form-label">Company Address</label>
                                        <Field
                                            type="text"
                                            id="address"
                                            name="address"
                                            className="input-field w-100"
                                            placeholder="Enter Company Address"
                                        />
                                        <ErrorMessage name="address" component="div" className="text-danger fs_12" />
                                    </div>
                                    <div className="form-group text-start mb-3">
                                        <label htmlFor="salutation" className="form-label">Salutation</label>
                                        <Field
                                            as="select"
                                            name="salutation"
                                            className="input-field w-100 overflow-auto"
                                            value={values.salutation}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            onClick={(e) => setSignIn(e.target.value)}
                                        >
                                            <option value="">Select Salutation</option>
                                            {salutation.map((sal) => (
                                                <option key={sal.value} value={sal.value}>
                                                    {sal.label}
                                                </option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="salutation" component="div" className="text-danger fs_12" />
                                    </div>

                                    <div className="form-group text-start mb-3">
                                        <label htmlFor="middle_name" className="form-label">Middle Name</label>
                                        <Field
                                            type="text"
                                            id="middle_name"
                                            name="middle_name"
                                            className="input-field w-100"
                                            placeholder="Enter Middle Name"
                                            onKeyPress={handleKeyPress}
                                        />
                                        <ErrorMessage name="middle_name" component="div" className="text-danger fs_12" />
                                    </div>

                                    <div className="form-group text-start mb-3">
                                        <label htmlFor="order_id" className="form-label">Order Id</label>
                                        <Field
                                            type="text"
                                            id="order_id"
                                            name="order_id"
                                            className="input-field w-100"
                                            placeholder="Enter ATH Order ID"
                                        />
                                        <ErrorMessage name="order_id" component="div" className="text-danger fs_12" />
                                    </div>
                                    {values.sign_in === "email" && (
                                        <div className="form-group text-start mb-3">
                                            <label htmlFor="password" className="form-label">Password</label>
                                            <div className="position-relative">
                                                <Field
                                                    type={showPassword ? 'text' : 'password'}
                                                    id="password"
                                                    name="password"
                                                    className="input-field w-100"
                                                    placeholder="Enter Password"
                                                />
                                                <span
                                                    onClick={toggleShowPassword}
                                                    className="position-absolute end-0 top-0 mt-2 me-2 text-secondary"
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    {showPassword ? 'Hide' : 'Show'}
                                                </span>
                                            </div>
                                            <ErrorMessage name="password" component="div" className="text-danger fs_12" />
                                        </div>
                                    )}
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group text-start mb-3">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <Field
                                            type="email"
                                            id="email"
                                            name="email"
                                            className="input-field w-100"
                                            placeholder="Enter Owner Email"
                                        />
                                        <ErrorMessage name="email" component="div" className="text-danger fs_12" />
                                    </div>

                                    <div className="form-group text-start mb-3">
                                        <label htmlFor="mobile" className="form-label">Mobile Number</label>
                                        <div className="d-flex gap-2">
                                            <CountryCodeDropdown selectedCode={selectedCode} setSelectedCode={setSelectedCode} />
                                            <Field
                                                type="text"
                                                id="mobile"
                                                name="mobile"
                                                className="input-field w-100"
                                                placeholder="Enter Mobile Number"
                                                disabled={!selectedCode}
                                            />
                                        </div>
                                        <ErrorMessage name="mobile" component="div" className="text-danger fs_12" />
                                    </div>
                                    <div className="form-group text-start mb-3">
                                        <label htmlFor="first_name" className="form-label">First Name</label>
                                        <Field
                                            type="text"
                                            id="first_name"
                                            name="first_name"
                                            className="input-field w-100"
                                            placeholder="Enter First Name"
                                            onKeyPress={handleKeyPress}
                                        />
                                        <ErrorMessage name="first_name" component="div" className="text-danger fs_12" />
                                    </div>
                                    <div className="form-group text-start mb-3">
                                        <label htmlFor="last_name" className="form-label">Last Name</label>
                                        <Field
                                            type="text"
                                            id="last_name"
                                            name="last_name"
                                            className="input-field w-100"
                                            placeholder="Enter Last Name"
                                            onKeyPress={handleKeyPress}
                                        />
                                        <ErrorMessage name="last_name" component="div" className="text-danger fs_12" />
                                    </div>
                                    <div className="form-group text-start mb-3">
                                        <label htmlFor="sign_in" className="form-label">Sign-in Method</label>
                                        <Field
                                            as="select"
                                            name="sign_in"
                                            className="input-field w-100"
                                            value={values.sign_in}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            onClick={(e) => setSignIn(e.target.value)}
                                        >
                                            <option value="" disabled>Select Sign-in Method</option>
                                            <option value="email">Email & Password</option>
                                            <option value="google">Google</option>
                                        </Field>
                                        <ErrorMessage name="sign_in" component="div" className="text-danger fs_12" />
                                    </div>

                                    {values.sign_in === "email" && (
                                        <>
                                            {/* <div className="form-group text-start mb-3">
                                                <label htmlFor="password" className="form-label">Password</label>
                                                <div className="position-relative">
                                                    <Field
                                                        type={showPassword ? 'text' : 'password'}
                                                        id="password"
                                                        name="password"
                                                        className="input-field w-100"
                                                        placeholder="Enter Password"
                                                    />
                                                    <span
                                                        onClick={toggleShowPassword}
                                                        className="position-absolute end-0 top-0 mt-2 me-2 text-secondary"
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        {showPassword ? 'Hide' : 'Show'}
                                                    </span>
                                                </div>
                                                <ErrorMessage name="password" component="div" className="text-danger fs_12" />
                                            </div> */}

                                            <div className="form-group text-start mb-3">
                                                <label htmlFor="confirmPassword " className="form-label">Confirm Password</label>
                                                <div className="position-relative">
                                                    <Field
                                                        type={showConfirmPassword ? 'text' : 'password'}
                                                        id="confirmPassword"
                                                        name="confirmPassword"
                                                        className="input-field w-100"
                                                        placeholder="Confirm Password"
                                                    />
                                                    <span
                                                        onClick={toggleShowConfirmPassword}
                                                        className="position-absolute end-0 top-0 mt-2 me-2 text-secondary"
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        {showConfirmPassword ? 'Hide' : 'Show'}
                                                    </span>
                                                </div>
                                                <ErrorMessage name="confirmPassword" component="div" className="text-danger fs_12" />
                                                <div className='' style={{ width: '20rem' }}>
                                                    <p className='text-start text-wrap mb-2 fs_12'>Your password must contain at least one uppercase letter, one lowercase letter, one number, and one special character, with a minimum length of 8 characters (e.g., Pass@123).</p>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>

                            <div className="d-flex justify-content-between px-3">
                                <button type="button" className="btn btn-primary" style={{ width: '100px' }} onClick={resetForm}>Reset</button>
                                <button type="submit" className="btn btn-primary" style={{ width: '100px' }} >Submit</button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>

        </div>
    );
};

export default Register;